import { tagBi } from '../analytics/BiTagger'
import { useSelector } from 'react-redux'
import { selectCurrentGeoentityId } from '../../store/geoentity/geoentity.selectors'

export default function useTagBiForGeoentity(biTagId, moreParams = {}) {
  const geoentityId = useSelector(selectCurrentGeoentityId)

  return () => tagBi(biTagId, { geoentity: geoentityId, ...moreParams })
}
